import { Observable, throwError } from 'rxjs';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { SignOut } from './auth.actions';
import { EMPTY } from 'rxjs';

@Injectable()
export class NeedLoginInterceptor implements HttpInterceptor {
  constructor(private router: Router, private store: Store) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    // Pass on the cloned request instead of the original request.
    return next.handle(req).pipe(
      catchError(err => {
        if (err && err.status === 401) {
          this.store.dispatch(new SignOut());
          // this.router.navigateByUrl('/login');
          return EMPTY;
        }
        return throwError(err);
      })
    );
  }
}
